import React from 'react';
import Button from '../../components/button';

export default props => {
  const { ux: { message }, actions } = props;

  return (
    <main>
      <div className="status-icon">
      </div>

      <div className="grow" style={{textAlign: 'center'}}>
        <p>
          <strong>Non è stato possibile effettuare la prenotazione.</strong>
        </p>

        <p>{message.text}</p>
      </div>

      <div className="actions">
        <div className="wrapper">
          <Button type="back" onClick={() => {
            actions.ux.setMessage(null);
            actions.ux.setBookingFormVisible(false);
            actions.booking.setBookingTime(null, false);
            actions.booking.setBookingDate(null, false);
          }}
          />
        </div>
      </div>
    </main>
  );
};



// WEBPACK FOOTER //
// ./src/containers/booking/booking-error.js